import { setUserId } from "@snowplow/browser-tracker";

import loggy from "@catchoftheday/loggy";

export type SpContextResult = {
  userId: null | string;
  contexts: SelfDescribingEvent[];
};

export type SelfDescribingEvent = {
  schema: string;
  data: Record<string, unknown>;
};

type StructEvent = {
  category: string;
  action: string;
  label?: string;
  property?: string;
  value?: number;
};

export async function spContext(
  pathname: string,
  queryString = ""
): Promise<SpContextResult | null> {
  try {
    const res = await fetch(`/sp-context${pathname}${queryString}`, {
      headers: { Accept: "application/json" },
    });
    const data: SpContextResult = await res.json();
    if (data.userId) {
      setUserId(data.userId);
    }
    return data;
  } catch (e) {
    loggy.error(e);
    return null;
  }
}

export async function spExperimentEvents(
  pathname: string
): Promise<Required<StructEvent>[]> {
  try {
    const response = await fetch(`/sp-experiment-events${pathname}`, {
      headers: { Accept: "application/json" },
    });
    const events = (await response.json()) as Required<StructEvent>[];
    return events;
  } catch (e) {
    loggy.error(e);
    return [];
  }
}
